import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import { useAuth } from '@sbv-clients/shared-feature-auth';
import { OverlayLoader } from '@sbv-clients/ui-shared';

type AuthGuardProps = PropsWithChildren;

const PrivateRouteGuard = ({ children }: AuthGuardProps) => {
  const { initialised, authenticated } = useAuth();

  if (!initialised) {
    return <OverlayLoader />;
  }

  if (initialised && !authenticated) {
    return <Navigate to="/auth/sign-in" />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default PrivateRouteGuard;
